import { render, staticRenderFns } from "./createYtml.vue?vue&type=template&id=54478ee9&scoped=true"
import script from "./createYtml.vue?vue&type=script&lang=js"
export * from "./createYtml.vue?vue&type=script&lang=js"
import style0 from "./createYtml.vue?vue&type=style&index=0&id=54478ee9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54478ee9",
  null
  
)

export default component.exports